// Dependencies
import { FC, MouseEventHandler } from "react";

// Components
import { Choose, When, If } from "jsx-control-statements";
import { HashLoading, IconButton } from "~/components/Common";

// Types
import { DefaultCategory } from "~/enums";
import { TCategoryDetailData, TQueryStatus } from "~/types";
// icons
import { ReactComponent as DeleteIcon } from "~/assets/icons/trash-can-regular.svg";
import { ReactComponent as EditIcon } from "~/assets/icons/pen-to-square-regular.svg";

// Styles
import {
  StyledInfoLabel,
  StyledInfoAction,
  StyledInfoDetail,
  StyledInfoWrapper,
  StyledInfoContent,
} from "~/components/Layout/LayoutInfo";
import { StyledErrorMessage } from "~/components/Layout";
import { StyledIcon, StyledName } from "./CategoryInfo.styled";
import { StyledDeleteButton } from "~/components/Transactions/TransactionInfo/TransactionInfo.styled";

interface CategoryInfoProps {
  data: TCategoryDetailData | undefined;
  error: string | undefined;
  status: TQueryStatus;
  onEdit: MouseEventHandler;
  onDelete: MouseEventHandler;
}

const CategoryInfo: FC<CategoryInfoProps> = ({
  data,
  error,
  status,
  onEdit,
  onDelete,
}) => {
  const editable = !data?.isDefault;
  return (
    <StyledInfoWrapper>
      <StyledInfoLabel>Category Detail</StyledInfoLabel>
      <StyledInfoContent>
        <Choose>
          <When condition={status.isLoading}>
            <HashLoading />
          </When>
          <When condition={status.isError}>
            <StyledErrorMessage>Error: {error}</StyledErrorMessage>
          </When>
          <When condition={status.isSuccess}>
            <If condition={editable}>
              <StyledInfoAction>
                <StyledDeleteButton onClick={onDelete}>
                  <DeleteIcon />
                </StyledDeleteButton>
                <IconButton onClick={onEdit}>
                  <EditIcon />
                </IconButton>
              </StyledInfoAction>
            </If>
            <StyledInfoDetail>
              <StyledIcon
                src={DefaultCategory[data?.id || "category_id"]?.icon}
              />
              <StyledName variant={"h3"}>{data?.name}</StyledName>
            </StyledInfoDetail>
          </When>
        </Choose>
      </StyledInfoContent>
    </StyledInfoWrapper>
  );
};

export default CategoryInfo;
